export const timeToGrowthMinutes = {
  '-1': {
    tutor: 3,
    instruct: {
      istationLegacyActivity: 2,
      microLesson: 7
    },
    teacherResource: 10,
  },
  '0': {
    tutor: 3,
    instruct: {
      istationLegacyActivity: 2,
      microLesson: 7
    },
    teacherResource: 10,
  },
  '1': {
    tutor: 5,
    instruct: {
      istationLegacyActivity: 2,
      microLesson: 7
    },
    teacherResource: 10,
  },
  '2': {
    tutor: 7,
    instruct: {
      istationLegacyActivity: 3,
      microLesson: 7
    },
    teacherResource: 10,
  },
  '3': {
    tutor: 8,
    instruct: {
      istationLegacyActivity: 4,
      microLesson: 7
    },
    teacherResource: 10,
  },
  '4': {
    tutor: 8,
    instruct: {
      istationLegacyActivity: 4,
      microLesson: 7
    },
    teacherResource: 10,
  },
  '5': {
    tutor: 8,
    instruct: {
      istationLegacyActivity: 5,
      microLesson: 7
    },
    teacherResource: 10,
  },
  '6': {
    tutor: 9,
    instruct: {
      istationLegacyActivity: 6,
      microLesson: 7
    },
    teacherResource: 10,
  },
  '7': {
    tutor: 9,
    instruct: {
      istationLegacyActivity: 6,
      microLesson: 7
    },
    teacherResource: 10,
  },
  '8': {
    tutor: 9,
    instruct: {
      istationLegacyActivity: 6,
      microLesson: 7
    },
    teacherResource: 10,
  },
}